import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AudioPlayer from "./AudioPlayer";
const SECONDS_TO_WAIT = 30;
export default function QuestionInfos({
  serieNbr,
  questionNbr,
  setQuestionNbr,
  isAudioFinished,
  setIsAudioFinished,
  questionMode,
}) {
  const [nbrOfSecondes, setNbrOfSecondes] = useState(SECONDS_TO_WAIT);

  const correctAnswer = new URLSearchParams(useLocation().search).get(
    "correctAnswer"
  );
  useEffect(() => {
    if (isAudioFinished && !correctAnswer && questionMode !== "pause") {
      const interval = setInterval(() => {
        setNbrOfSecondes((s) => {
          if (s >= 1) return s - 1;
        });
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [isAudioFinished, questionMode]);

  useEffect(() => {
    if (nbrOfSecondes === 0) {
      setQuestionNbr((q) => q + 1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nbrOfSecondes]);

  useEffect(() => {
    setIsAudioFinished(false);
    if (nbrOfSecondes !== SECONDS_TO_WAIT) {
      setNbrOfSecondes(SECONDS_TO_WAIT);
    }
  }, [questionNbr]);

  return (
    <div className="question-infos">
      <div className="question-info">
        <span>
          <div>الوقت المتبقي</div>
          <div>Temps Restant</div>
        </span>
        <img src="assets/clock.svg" style={{width:"3vw"}} alt="clock" />
        <h1>{nbrOfSecondes}</h1>
      </div>
      <div className="question-info">
        <span>
          <div>السؤال</div>
          <div>Question</div>
        </span>
        <h1>{questionNbr}</h1>
      </div>
      <div className="question-info">
        <span>
          <div>الصوت</div>
          <div>Volume</div>
        </span>
        <span>
          <AudioPlayer
            {...{ questionNbr, serieNbr, setIsAudioFinished, questionMode }}
          />
        </span>
      </div>
    </div>
  );
}
